module.exports = __webpack_public_path__ + "static/media/google-google-plus-svgrepo-com.1fc96fed.svg";